import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";
import { useCallback, useState } from "react";
import { message } from "antd";
import { showErrorToast } from "V2.0/utils";
import UserProfile from "./UserProfile";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

export default function UserDeactivateConfirm(props) {
  const { onCancel, user, onDeactivateUser } = props;

  const [loading, setLoading] = useState<boolean>(false);

  const handleDeactivate = useCallback(
    async function () {
      const lifecycleCbs = {
        init: () => {
          setLoading(true);
          message.loading(`Deactivating ${user?.email ?? "User"}`);
        },
        success: () => {
          message.destroy();
          message.success(`${user?.email ?? "User"} deactivated`);
          setLoading(false);
          onCancel();
        },
        error: (e) => {
          message.destroy();
          setLoading(false);
          showErrorToast(e, "Failed to deactive User");
        },
      };

      onDeactivateUser(lifecycleCbs, user);
    },
    [user, onCancel]
  );

  return (
    <Dialog
      open={true}
      onClose={onCancel}
    >
      <DialogTitle>{`Deactivate User?`}</DialogTitle>
      <DialogBody className="space-y-8">
        <UserProfile
          firstName={user?.firstName}
          lastName={user?.lastName}
          email={user?.email}
        />
        <div className="flex items-center gap-x-2">
          <InformationCircleIcon className="size-4 text-orange-500" />
          <p className="text-sm text-orange-500">
            Note: Once deactivated, the user will no longer be able to log in.
          </p>
        </div>
      </DialogBody>
      <DialogActions>
        <Button
          outline
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          onClick={handleDeactivate}
          loading={loading}
          disabled={loading}
        >
          Yes, deactivate
        </Button>
      </DialogActions>
    </Dialog>
  );
}
